export interface UserCourseDto {
  userId: number;
  courseId: number;
  dateEnrolment?: Date;        // Optional - can be undefined
  isCertificateSent?: string;  // Optional - can be undefined
  isCourseComplete: string;    // Required field
  whenCourseCompleted?: Date;  // Optional - can be undefined
}

// Helper function to create UserCourseDto with defaults
//- `Partial<UserCourseDto>` means all properties are optional in the input
//- `Pick<UserCourseDto, 'userId' | 'courseId' | 'isCourseComplete'>` ensures these three critical fields must be provided
// - The intersection (`&`) combines these types, making some fields required while keeping others optional
export function createUserCourseDto(partial: Partial<UserCourseDto> & Pick<UserCourseDto, 'userId' | 'courseId' | 'isCourseComplete'>): UserCourseDto {
  return {
    dateEnrolment: new Date(),
    isCertificateSent: 'false',
    whenCourseCompleted: new Date(),
    ...partial  // Override with provided values
  };
}
